<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button
            link="/voyage-monitoring/consumption-types"
          ></back-button>
          Update Consumption Type
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Voyage Monitoring</li>
          <li class="breadcrumb-item">
            <router-link :to="`/voyage-monitoring/consumption-types`"
              >Consumption Types</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Update</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-10 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Vessel</label>
              <div class="col-sm-10">
                <my-select
                  style="margin: 9px !important"
                  disableFormControl="true"
                  :selection.sync="form.vessel_id"
                  :suggestions="vessels"
                  placeholder="Select vessel"
                ></my-select>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Item Name</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  v-model="form.item_name"
                  class="form-control"
                  placeholder="Item name"
                />
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Item Code</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  v-model="form.item_code"
                  class="form-control"
                  placeholder="Item code"
                />
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Measure</label>
              <div class="col-sm-10">
                <my-select
                  style="margin: 9px !important"
                  disableFormControl="true"
                  :selection.sync="form.measure_id"
                  :suggestions="measures"
                  placeholder="Select measure"
                ></my-select>
              </div>
            </div>
            <div class="form mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="update"
                text="Update"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "ConsumptionTypeUpdate",
  data() {
    return {
      form: {
        vessel_id: "",
        measure_id: "",
      },
      vessels: [],
      measures: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("consumption_types/masters");
      masters = masters.data;
      masters.vessels.forEach((vessel) => {
        this.vessels.push({
          id: vessel.id,
          name: vessel.name,
        });
      });
      masters.measures.forEach((measure) => {
        this.measures.push({
          id: measure.id,
          name: measure.name,
        });
      });
    },
    async getData() {
      this.isLoading = true;
      let form = await axios.get(
        `/consumption_types/${this.$route.params.ctId}`
      );
      this.form = form.data.data;
      this.isLoading = false;
    },
    async update() {
      try {
        this.isLoading = true;
        await axios.patch(
          `/consumption_types/${this.$route.params.ctId}`,
          this.form
        );
        this.isLoading = false;
        this.$router.push("/voyage-monitoring/consumption-types");
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
